import { useMemo, useState } from 'react';
import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import ProjectModal from '../ProjectModal/ProjectModal';
import './Projects.css';

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const [activeProject, setActiveProject] = useState(null);

  const tags = useMemo(
    () => ['All', ...new Set(portfolioData.projects.map((project) => project.tag))],
    []
  );

  const featured = portfolioData.projects.filter((project) => project.featured);
  const filtered = portfolioData.projects.filter((project) => {
    const matchesFilter = filter === 'All' || project.tag === filter;
    // Avoid repeating featured projects in the grid when showing everything
    if (filter === 'All' && project.featured) return false;
    return matchesFilter;
  });

  return (
    <section className="section projects" id="projects">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="section-eyebrow">Projects</p>
            <h2 className="section-title">Selected work</h2>
            <p className="section-lead">
              Production apps, AI products, and full-stack systems — with live store links where available.
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="projects__featured">
            {featured.map((project) => (
              <button
                key={project.id}
                type="button"
                className="projects__feature"
                onClick={() => setActiveProject(project)}
              >
                <div className="projects__feature-media">
                  <img src={project.images[0]} alt="" />
                </div>
                <div className="projects__feature-body">
                  <span className="projects__tag">{project.tag}</span>
                  <h3>{project.title}</h3>
                  <p>{project.caption}</p>
                  <ul className="projects__tech">
                    {project.tech.slice(0, 4).map((tech) => (
                      <li key={tech}>{tech}</li>
                    ))}
                  </ul>
                </div>
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal>
          <div className="projects__filters" role="tablist" aria-label="Filter projects">
            {tags.map((tag) => (
              <button
                key={tag}
                type="button"
                role="tab"
                aria-selected={filter === tag}
                className={filter === tag ? 'is-active' : ''}
                onClick={() => setFilter(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="projects__grid">
          {filtered.map((project, index) => (
            <Reveal key={project.id} delay={(index % 3) + 1}>
              <button
                type="button"
                className="projects__card"
                onClick={() => setActiveProject(project)}
              >
                <div className="projects__card-media">
                  <img src={project.images[0]} alt="" />
                </div>
                <div className="projects__card-body">
                  <span className="projects__tag">{project.tag}</span>
                  <h3>{project.title}</h3>
                  <p>{project.caption}</p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <ProjectModal project={activeProject} onClose={() => setActiveProject(null)} />
    </section>
  );
};

export default Projects;
